var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.999,
    height: 36,
    viewBox: "0 0 35.999 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medical-history-2",
    transform: "translate(-0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(9.395 4.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M112.438,48H96.787a.783.783,0,0,0,0,1.565h15.652a.783.783,0,0,0,0-1.565Z",
    transform: "translate(-96.004 -48)",
    fill: "#f6781b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(4.7 23.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M55.047,243.13H52.7v-2.348a.783.783,0,1,0-1.565,0v2.348H48.787a.783.783,0,1,0,0,1.565h2.348v2.348a.783.783,0,1,0,1.565,0V244.7h2.348a.783.783,0,0,0,0-1.565Z",
    transform: "translate(-48.004 -240)",
    fill: "#0060a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(15.656 23.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M174.873,240H160.787a.783.783,0,0,0-.783.783v6.261a.783.783,0,0,0,.783.783h14.087a.782.782,0,0,0,.783-.783v-6.261A.782.782,0,0,0,174.873,240Zm-.783,6.261H161.569v-4.7h12.521Z",
    transform: "translate(-160.004 -240)",
    fill: "#0060a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(9.395 9.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M112.438,96H96.787a.783.783,0,0,0,0,1.565h15.652a.783.783,0,0,0,0-1.565Z",
    transform: "translate(-96.004 -96)",
    fill: "#f6781b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(15.656 14.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M170.178,144h-9.391a.783.783,0,1,0,0,1.565h9.391a.783.783,0,0,0,0-1.565Z",
    transform: "translate(-160.004 -144)",
    fill: "#f6781b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M33.655,6.261H31.308V.783A.782.782,0,0,0,30.525,0H5.482A.783.783,0,0,0,4.7.783V6.261H2.352A2.351,2.351,0,0,0,0,8.609v24.26C0,35.177,1.216,36,2.352,36H32.31c.6,0,1.031,0,1.345-.027V36A2.351,2.351,0,0,0,36,33.651V8.609A2.351,2.351,0,0,0,33.655,6.261ZM6.265,1.565H29.742V18.782H6.265Zm-4.7,7.043a.783.783,0,0,1,.783-.783H4.7V18.782H1.569V8.609ZM34.438,33.651a.784.784,0,0,1-.785.783H2.352c-.707,0-.783-1.095-.783-1.566V20.347H34.438Zm0-14.869h-3.13V7.826h2.348a.783.783,0,0,1,.783.783Z",
    transform: "translate(-0.004)",
    fill: "#f6781b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReports);
export default __webpack_public_path__ + "static/media/icon_reports.01dc1526cc3e2dcf48c188eb9dd36a6d.svg";
export { ForwardRef as ReactComponent };